export default {
    BASE_URL: location.port == 8080 ? 'http://newfrontend.test.ebiljett.nu' : '',
    STATIC_FILES: location.port == 8080,
    ARENA_DATA_URL: location.port == 8080 ? '/seating/ArenaInfo2?eventid=' : '/seating/ArenaInfo?eventid=',
    CART_DATA_URL:  '/cart/GetCartWithSeatingInfo' ,
    RESERVE_SEATS_URL: '/seating/ReserveSeats/',
    CLEAR_UNSEATEDTICKETS_URL: '/cart/RemoveUnseatedTickets/',
    SECTION_DATA_URL: '/seating/SectionData?section=',
    SECTION_DATA_URL_STATIC: './json/sectiondata.json',
    
    STATE_SEATS_GROUPED: 'grouped',
    STATE_SEATS_UNGROUPED: 'ungrouped',
    STATE_SECTIONS_GROUPED: 'grouped',
    STATE_SECTIONS_UNGROUPED: 'ungrouped'
}